import { useLanguage } from '../context/LanguageContext'

/**
 * Small EN | FR switcher (EPIC #106 P2). Drives LanguageContext.langId,
 * which t() reads. Used in the reseller portal sidebar (dark) and the
 * customer embed header (light). v1 = English (1) + French (2).
 *
 * Note: changing the language only re-translates surfaces that have been
 * wired to t() — the embed (P3) and operator portal (P4). Until then it
 * still drives the "How it works" disclosure and any already-keyed string.
 */
const LANGS = [{ id: 1, label: 'EN' }, { id: 2, label: 'FR' }]

export default function LanguageToggle({ dark = false }) {
  const { langId, setLangId } = useLanguage()
  const border   = dark ? '#334155' : '#e2e8f0'
  const activeBg = dark ? '#00d19f' : '#0f172a'
  const activeFg = dark ? '#0f172a' : '#fff'
  const idleBg   = dark ? 'transparent' : '#fff'
  const idleFg   = dark ? '#94a3b8' : '#64748b'
  return (
    <div style={{ display: 'inline-flex', border: `1px solid ${border}`, borderRadius: 6, overflow: 'hidden' }}>
      {LANGS.map(l => {
        const active = langId === l.id
        return (
          <button
            key={l.id}
            type="button"
            onClick={() => setLangId(l.id)}
            aria-pressed={active}
            style={{
              padding: '4px 10px', border: 'none', cursor: 'pointer',
              fontSize: 12, fontWeight: 700,
              background: active ? activeBg : idleBg,
              color: active ? activeFg : idleFg,
            }}
          >
            {l.label}
          </button>
        )
      })}
    </div>
  )
}
